import { client } from "@/http/client"

import { IResponse } from "@/types/api"

export const markAsSelectTransport =(id: number, amount?: number) 
: Promise<IResponse<number>> => 
    client.put("/ShippingSchedule/mark-select-transport", {
        shippingScheduleId: id,
        amount: amount
    })

export const cancelShippingSchedule =(id: number) 
: Promise<IResponse<number>> => 
    client.put("/ShippingSchedule/Cancel", {
        shippingScheduleId: id
    })